export default {
  'app.setting.pagestyle':'Page style setting',
  'app.setting.pagestyle.light': 'Light style',
  'app.setting.pagestyle.dark': 'Dark style',
  'app.setting.pagestyle.realdark': 'RealDark style',
  'app.setting.themecolor': 'Theme Color',
  'app.setting.navigationmode': 'Navigation Mode',
  'app.setting.content-width': 'Content Width',
  'app.setting.fixedheader': 'Fixed Header',
  'app.setting.fixedsidebar': 'Fixed Sidebar',
  'app.setting.multitab': 'Show tabs',
  'app.setting.sidemenu': 'Side Menu Layout',
  'app.setting.topmenu': 'Top Menu Layout',
  'app.setting.content-width.fixed': 'Fixed',
  'app.setting.content-width.fluid': 'Fluid',
  'app.setting.othersettings': 'Other Settings',
  'app.setting.weakmode': 'Color Weak Mode',
  'app.setting.copy': 'Copy Setting',
  'app.setting.loading': 'Loading theme',
  'app.setting.copyinfo': 'Copy success src/config/defaultSettings.js',
  'app.setting.production.hint': 'Setting panel shows in development environment only, please manually modify config file after copying',
  'app.setting.themecolor.daybreak': 'Daybreak Blue',
  'app.setting.themecolor.dust': 'Dust Red',
  'app.setting.themecolor.volcano': 'Volcano',
  'app.setting.themecolor.sunset': 'Sunset Orange',
  'app.setting.themecolor.cyan': 'Cyan',
  'app.setting.themecolor.green': 'Aurora Green',
  'app.setting.themecolor.geekblue': 'Geek Blue',
  'app.setting.themecolor.purple': 'Golden Purple',

  '系统用户': {
    '开始时间': 'Start Date',
    '结束时间': 'End Date'
  },

  '通用': {
    '按钮': {
      '新增': 'Add',
      '确定': 'Confirm',
      '审核': 'Audit',
      '修改': 'Edit',
      '复制': 'Duplicate',
      '删除': 'Delete',
      '解绑': 'Unbind',
      '关闭': 'Close',
      '导出': 'Export',
      '选中导出': 'Export Selected',
      '导入': 'Import',
      '查询': 'Search',
      '重置': 'Reset',
      '详情': 'Detail',
      '上传': 'Upload',
      '展开': 'Expand',
      '收起': 'Collapse',
      '更多': 'More',
      '保存': 'Save',
      '取消': 'Cancel',
      '翻译': 'Translate',
      '刷新缓存': 'Refresh Cache',
      '详情及审核': 'Detail & Audit',
      '客服': 'Customer Service',
      '平台客服': 'Platform Customer Service'
    },
    '输入':{
      '请输入':'Please enter ',
      '请输入数量':'Please enter quantity',
      '请选择':'Please select ',
      '数量':'Quantity',
    },
    '文本': {
      '是': 'Yes',
      '否': 'No',
      '状态': 'Status',
      '名称': 'Name',
      '启用': 'Enable',
      '禁用': 'Disable',
      '操作': 'Operation',
      '操作成功': 'Operation Successful',
      '添加': 'Add',
      '创建时间': 'Created Time',
      '更新时间': 'Update Time',
      '排序': 'Sort',
      '修改': 'Edit',
      '详情': 'Detail',
      '确认删除所选中数据': 'Confirm deletion of selected data?',
      '删除成功': 'Delete Success',
      '确认取消': 'Confirm cancel?',
      '取消成功': 'Cancel Success',
      '新增成功': 'Add Success',
      '修改成功': 'Edit Success',
      '上传成功': 'Upload Success',
      '共': 'Total ',
      '条': ' records',
      '默认': 'Default',
      '中等': 'Medium',
      '紧凑': 'Compact',
      '列展示排序': 'Column Display/Sort',
      '列排序需拖动名称': 'Column sorting requires dragging name',
      '不能为空': 'Cannot be empty',
      '不能小于0': 'Cannot be less than 0',
      '多语言配置': 'Multi-language Configuration',
      '语言': 'Language',
      '根节点': 'Root Node',
      '创建开始时间': 'Create Start Time',
      '创建结束时间': 'Create End Time',
      '选择商品': 'Select Product',
      '详情及审核': 'Detail & Audit',
      '确认核销': 'Confirm verification?',
      '核销成功': 'Verification Success',
      '是否确认导出': 'Confirm export?',
      '此操作将导出当前条件下所有数据而非选中数据': 'This will export all data under current conditions instead of selected data',
      '此操作将导出选中数据': 'This will export selected data',
    },
  },
  '广告': {
    '新增': 'Add Banner',
    '位置': 'Placement',
    '跳转类型': 'Link Type',
    '广告名称': 'Banner Name',
    '开始时间': 'Start Time',
    '结束时间': 'End Time',
    '选择申请': 'Select Application',
    '外链': 'External Link',
    '内容详情': 'Content Details',
    '排行榜活动': 'Ranking Activity',
    '投票活动': 'Voting Activity',
    '资讯详情': 'News Details',
    '是否隐藏': 'Is Hidden',
    '展示时长': 'Display Duration',
    '展示次数': 'Display Count',
    '点击次数': 'Click Count',
    '跳转次数': 'Jump Count',
    '封面图': 'Cover Image',
    '详情图': 'Detail Image',
    '创建时间': 'Create Time',
  },

  '商品分类': {
    '商品分类': 'Product Category',
    '分类名称': 'Category Name',
    '分类图片': 'Category Image',
    '上级分类': 'Parent Category',
    '分类等级': 'Category Level',
    '是否显示': 'Visibility',
    '是否新品': 'Now Available',
    '新增': 'Add Category',
    '是否首页展示': 'Is Homepage Display',
    '是否参与筛选': 'Is Filterable',
    '创建时间': 'Create Time',
    '分类类型': 'Category Type',
    '国内': 'Domestic',
    '跨境': 'Cross-border',
  },
  '商品标签':{
    '标签名称':'Tag Name',
    '图标':'Icon',
    '颜色':'Color',
    '状态':'Status',
    '创建时间':'Create Time',
    '更新时间':'Update Time',
    '备注':'Remark',
  },
  '商品': {
    '新增': 'Add Product',
    '套餐': 'Package',
    '标签': 'Tag',
    '备注': 'Remark',
    '售卖区域': 'Sales Area',
    '批量上架': 'Bulk Publish',
    '批量下架': 'Bulk Unpublish',
    '批量复制': 'Bulk Duplicate',
    '确认复制': 'Confirm copy?',
    '复制成功': 'Copy Success',
    '选择明星': 'Select Star',
    '选择运费模板': 'Select Shipping Template',
    '基础信息': 'Basic Information',
    '标签信息': 'Tag Information',
    '规格信息': 'Specification Information',
    '详情信息': 'Detail Information',
    '上架成功': 'On Sale Success',
    '下架成功': 'Off Sale Success',
    '确认上架': 'Confirm on sale?',
    '确认下架': 'Confirm off sale?',
    '添加规格': 'Add Specification',
    '修改规格': 'Edit Specification',
    '商品类型': 'Product Type',
    '商品': 'Product',
    '明星': 'Star',
    '限购数': 'Purchase Limit',
    '售卖开始时间': 'Sale Start Time',
    '售卖结束时间': 'Sale End Time',
    '是否多规格': 'Is Multi-spec',
    '是否允许合并购买': 'Allow Merge Purchase',
    '商品颜色': 'Product Color',
    '商品详情': 'Product Details',
    '市场价': 'Market Price (Strikethrough Price)',
    '成本价': 'Cost Price',
    '积分价': 'Points Price',
    '虚拟销量': 'Virtual Sales',
    '是否展示销量': 'Show Sales',
    '商品价': 'Product Price',
    '商品编号': 'Product ID',
    '店铺名称': 'Store Name',
    'SKU编号': 'SKU Code',
    '商品条码': 'Product Barcode',
    'SKU名字': 'Specification',
    '售卖店铺': 'Sales Store',
    '规格名称': 'Variant',
    '商品名称': 'Product Name',
    '商品重量': 'Product Weight',
    '包装单位': 'Package Unit',
    '商品主图': 'Product Image',
    '商品视频': 'Product Video',
    '商品轮播图': 'Gallery Images',
    '商品分类': 'Category',
    '店铺商品分类': 'Store Product Category',
    '跨境商品分类': 'Cross-border Category',
    '国家': 'Country',
    '商品关键词': 'Product Keywords',
    '品牌': 'Brand',
    '运费模板': 'Shipping Template',
    '商品价格': 'Sale Price',
    '活动价格': 'Activity Price',
    '积分价格': 'Points',
    '秒杀价格': 'Seckill Price',
    '团购价格': 'Group Price',
    '会员价格': 'Member Price',
    '限购数量': 'Purchase Limit',
    '商品库存': 'Stock',
    '商品限购数量': 'Product Purchase Limit',
    '预警库存': 'Warning Stock',
    '商品状态': 'Status Information',
    '实际销量': 'Actual Sales',
    '售卖范围': 'Sales Range',
    '是否推荐': 'Featured',
    '是否新品': 'Is New',
    '是否甄选': 'Is Selected',
    '是否样品': 'Is Sample',
    '是否日历展示': 'Show in Calendar',
    '是否精品': 'Is Premium',
    '是否免费领': 'Is Free',
    '是否限购': 'Is Limited',
    '是否爆款': 'Is Hot',
    '售后方式': 'After-sales Method',
    '创建时间': 'Create Time',
    '规格': {
      '添加规格值': 'Add Specification Value',
      '规格名称': 'Specification Name',
      '规格值': 'Specification Value',
      '是否可见': 'Visibility',
      '规格图片': 'Specification Image',
      '是否有规格图片': 'Has Specification Image',
    },
    'sku': {
      '名称': 'Name',
      '编码': 'Code',
      '价格': 'Price',
      '活动价格': 'Activity Price',
      '库存': 'Stock',
      '重量': 'Weight',
      '图片': 'Image',
    },
  },
  '品牌': {
    '品牌名称': 'Brand Name',
    '品牌备注': 'Brand Remark',
    '品牌首字母': 'Brand Initial',
    'logo': 'Logo',
    '创建时间': 'Create Time',
  },
  '明星分类': {
    '分类名称': 'Category Name',
    '是否显示': 'Visibility',
    '创建时间': 'Create Time',
    '备注': 'Remark',
  },
  '明星': {
    '明星名字': 'Star Name',
    '明星分类': 'Star Category',
    '明星照片': 'Star Photo',
    '背景图': 'Background Image',
    '网址': 'Website',
    '状态': 'Status',
    '基础粉丝数': 'Base Fans',
    '关注数': 'Followers',
    '明星介绍': 'Star Introduction',
    '创建时间': 'Create Time',
    '备注': 'Remark',
  },
  '明星俱乐部': {
    '俱乐部名字': 'Club Name',
    '商品数': 'Product Count',
    '创建时间': 'Create Time',
    '备注': 'Remark',
  },

  '活动分类':{
    '位置':'Position',
    '导航位名称':'Navigation Name',
    '状态':'Status',
    '排序':'Sort',
    '创建者':'Creator',
    '创建时间':'Create Time',
    '修改人':'Modifier',
    '更新时间':'Update Time',
    '备注':'Remark',
    '图片':'Image',
  },
  '活动记录': {
    '活动编号':'Activity Code',
    '商品最大购买数量':'Max Purchase Quantity',
    '排行':'Ranking',
    '选择活动':'Select Activity',
    '是否上架':'Is On Sale',
    '活动类型':'Activity Type',
    '活动名称':'Event Name',
    '开始时间':'Start Time',
    '结束时间':'End Time',
    '活动封面图':'Activity Cover',
    '分享海报图':'Share Poster',
    '分享文案':'Share Text',
    '限制会员等级':'Limit Member Level',
    '最多参与次数':'Max Participation',
    '活动详情':'Activity Details',
    '状态':'Status',
    '是否展示到日历':'Show in Calendar',
    '创建时间':'Create Time',
    '活动参与区域':'Activity Participation Area'
  },
  '运费模板': {
    '计费方式':'Billing Method'
  },
  '收货地址': {
    '应援地址':'Support Address',
    '收货区域':'Receiving Area',
    '收货人手机号':'Receiver Phone',
  },
  '广告投放审核': {
    '联系电话': 'Contact Phone',
    '广告名称': 'Ad Name',
    '广告简介': 'Ad Introduction',
    '广告活动开始时间': 'Start Time',
    '广告活动结束时间': 'End Time',
    '审核状态': 'Audit Status',
    '审核时间': 'Audit Time',
    '姓名': 'Name',
    '创建时间':'Create Time',
    '原因': 'Reason',
    '是否通过': 'Is Approved',
  },
  '订单取消原因': {
    '名称':'Name',
    '类型':'Type',
    '创建时间':'Create Time',
    '是否显示':'Visibility',
  },

  '等级设置': {
    '会员等级名称': 'Level Name',
    '会员等级卡片名称': 'Card Name',
    '会员等级':'Member Level',
    '升级所需经验':'Experience Required',
    '等级图片': 'Level Image',
    '等级图标': 'Level Icon',
    '会员等级排序': 'Level Sort',
    '升级所需积分': 'Points Required',
  },
  '商品足迹': {
    '商品名称': 'Product Name',
    '商品主图': 'Main Image',
    '排序': 'Sort',
    '搜索次数': 'Search Count',
    '创建时间': 'Create Time',
  },
  '订单发货记录': {
    '发货方式': 'Shipping Method',
    '发货人手机号': 'Shipper Phone',
    '发货时间': 'Shipping Time',
    '发货记录编号': 'Shipping Record Code',
    '发货开始时间': 'Shipping Start Time',
    '发货结束时间': 'Shipping End Time',
  },
  '举报':{
    '举报内容':'Report Content',
    '创建时间':'Create Time',
    '人员信息':'Personnel Information'
  },

  '销售订单': {
    '全部订单': 'All Orders',
    '此操作将导出当所有待发货订单而非选中数据':'This will export all pending shipment orders instead of selected data',
    '导出待发货':'Export Pending Shipment',
    '导入发货单':'Import Shipping List',
    '接单':'Accept Order',
    '接单成功':'Accept Success',
    '物流公司':'Logistics Company',
    '物流单号':'Tracking Number',
    '物流详情':'Logistics Details',
    '寄件人手机号':'Sender Phone',
    '订单编号':'Order Number',
    '订单类型':'Order Type',
    '订单来源':'Order Source',
    '平台币抵扣':'Points Deducted',
    '积分抵扣':'Points Deduction',
    '积分':'Points Used',
    '订单数量':'Order Quantity',
    '订单信息':'Order Information',
    '订单详情':'Order Details',
    '三方订单号':'Third-party Order Number',
    '买家名称':'Customer Name',
    '买家信息':'Buyer Information',
    '手机号或邮箱':'Phone or Email',
    '订单状态':'Order Status',
    '下单时间':'Order Time',
    '配送信息':'Delivery Information',
    '配送方式':'Delivery Method',
    '下单开始时间':'Order Start Time',
    '下单结束时间':'Order End Time',
    '支付方式':'Payment Method',
    '支付时间':'Payment Time',
    '退款状态':'Refund Status',
    '商品数量':'Item Quantity',
    '商品金额':'Product Amount',
    '商品实付金额':'Actual Product Amount',
    '优惠金额':'Discount Amount',
    '平台抽成':'Platform Commission',
    '订单金额':'Order Amount',
    '运费金额':'Shipping Amount',
    '运费实付':'Actual Shipping Paid',
    '平台币':'Platform Coin',
    '用户备注':'User Remark',
    '商品信息':'Product Details',
    '活动信息':'Activity Information',
    '收货地址信息':'Shipping Address Information',
    '提货地址信息': 'Pickup Information',
    '实付单价':'Actual Unit Price',
    '数量':'Quantity',
    '收货人姓名':'Pickup Location',
    '核销码':'Verification Code',
    '性别':'Gender',
    '手机号':'Contact Phone',
    '邮箱':'Email',
    'ID/邀请码':'ID/Invitation Code',
    '地址类型':'Address Type',
    '地区':'Area',
    '详细地址':'Pickup Address',
    '发货':'Fulfill Order',
    '确认提货':'Confirm Pickup',
    '核销':'Verify',
    '发货成功':'Ship Success',
    '取消订单':'Cancel Order',
    '核销订单':'Verify Order',
    '发货备注':'Shipping Remark',
    '核销备注':'Verification Remark',
    '店铺名称':'Store Name',
    '订单原价':'Original Order Price',
    '实付金额':'Actual Paid Amount',
    '运费':'Shipping Fee',
    '是否首单':'Is First Order',
    '是否催发货':'Is Urging Shipment',
    '预约日期':'Appointment Date',
    '预约开始时间':'Appointment Start Time',
    '预约结束时间':'Appointment End Time',
    '是否需要预约':'Need Appointment',
    '售卖结束时间':'Sale End Time',
    '套餐信息':'Package Information',
    '人员信息':'Personnel Information',
  },
  '售后订单': {
    '原订单编号': 'Original Order Number',
    '售后单编号': 'After-sales Order Number',
    '售后类型': 'After-sales Type',
    '售后状态': 'After-sales Status',
    '售后凭证': 'After-sales Points',
    '购买数量': 'Purchase Quantity',
    '售后数量': 'After-sales Quantity',
    '申请开始时间':'Application Start Time',
    '申请结束时间':'Application End Time',
    '退款金额': 'Refund Amount',
    '申请时间': 'Application Time',
    '售后原因': 'After-sales Reason',
    '寄回备注': 'Return Remark',
    '寄回凭证': 'Return Points',
    '售后信息': 'After-sales Information',
    '原订单信息': 'Original Order Information',
    '订单详情':'Order Details',
    '售后详情':'After-sales Details',
    '售后商品':'After-sales Product',
    '备注':'Remark',
    '审核':'Audit',
    '是否同意':'Is Approved',
    '拒绝原因':'Rejection Reason',
    '审核成功':'Audit Success',
    '退款': 'Refund',
    '是否确认退款': 'Confirm refund?',
    '退款成功': 'Refund Success',
    '收货地址':'Shipping Address',
  },

  '用户': {
    '用户信息':'User Information',
    '发送消息':'Send Message',
    '手机号':'Phone',
    '联系方式':'Contact Information',
    '用户等级':'Level',
    '邮箱':'Email',
    '昵称':'Nickname',
    '微信':'WeChat',
    '积分':'Points Used',
    '角色类型':'Role Type',
    '真实姓名':'Real Name',
    '身份证':'ID Card',
    '头像':'Profile Picture',
    '审核状态':'Audit Status',
    '性别':'Gender',
    '生日':'Birthday',
    '钱包':'Wallet',
    '员工':'Employee',
    '营养师':'Nutritionist',
    '用户':'User',
    '邀请码':'Invitation Code',
    '注册时间':'Registration Time',
    '用户状态':'User Status',
    '解封时间':'Unblock Time',
    '健康状况':'Health Status',
    '婚姻状况':'Marital Status',
    '兴趣爱好':'Hobbies',
    '职业':'Occupation',
    '保密':'Confidential',
    '男':'Male',
    '女':'Female',
    '用户个性签名':'User Signature',
    '备注':'Remark',
    '寄存':'Store Plush',
    '金币兑换游戏币':'Convert Coins to Tokens',
    '店内扣除积分':'Manually Deduct Points',
    '游戏币寄存':'Store Tokens',
    '游戏币提取':'Deduct Tokens',
    '总积分':'Total Points',
    '总游戏币':'Total Tokens',
    '总金币':'Total Coins',
    '金币':'Gold Coins',
    '游戏币':'tokens',
    'ID/邀请码':'ID/Invitation Code',
    '查看我邀请的人':'ViewMyInvitations',
    '全部':'All',
    '我的直推':'My Direct Push',
  },
  '用户积分变动记录':{
    '订单编号':'Order Number',
    '备注':'Remark',
    '手动操作积分':'Manually Adjust Points',
    '选择用户':'Select User',
    '请输入积分数量':'Please enter the points amount',
    '变动的积分数':'Points Change',
    '积分数量':'Points Amount',
    '请选择用户':'Please select user',
    '操作类型':'Operation Type',
    '增加积分':'Add Points',
    '减少积分':'Deduct Points',
    '变动前剩余积分':'Points Before',
    '变动后剩余积分':'Points After',
  },
  '用户金币变动记录':{
    '订单编号':'Order Number',
    '备注':'Remark',
    '变动的金币数':'Gold Coins Change',
    '变动前剩余金币':'Gold Coins Before Change',
    '变动后剩余金币':'Gold Coins After Change',
    '有效期':'Expiration Date',
    '已使用金币':'Used Gold Coins',
  },
  '用户游戏币变动记录':{
    '订单编号':'Order Number',
    '备注':'Remark',
    '变动的游戏币数':'Tokens Change',
    '变动前剩余游戏币':'Tokens Before Change',
    '变动后剩余游戏币':'Tokens After Change'
  },
  '用户投票记录':{
    '活动名称':'Event Name',
    '商品名称':'Product Name',
    '商品图片':'Product Image',
    '是否中奖':'Is Winner',
    '到达积分':'Points Achieved',
    '累计积分':'Accumulated Points',
    '积分':'Points',
    '奖品':'Reward',
    '领取状态':'Claim Status',
    '发放奖品':'Distribute Prize',
    '已领取':'Claimed',
    '未领取':'Unclaimed',
    '已中奖':'Winner',
    '未中奖':'Not Winner',
  },
  '电子集卡':{
    '电子卡片':'Digital Card',
    '请选择用户':'Please select user',
    '手机号':'Phone Number',
    '新增':'Add',
  },
  "直播间连麦":{
    '直播间创建人': 'Live Room Creator',
    '连麦类型':'Link Type',
    '直播间':'Live Room',
    '连麦状态':'Link Status',
    '连麦静音状态':'Mute Status',
    '摄像头状态':'Camera Status',
    '管理员连麦状态':'Admin Link Status',
    '创建时间':'Create Time'
  },
  '用户搜索记录': {
    '类型':'Type',
    '搜索内容':'Search Content',
    '搜索次数':'Search Count',
    '创建时间':'Create Time',
  },

  '用户注销': {
    '联系电话':'Contact Phone',
    '注销原因':'Deactivation Reason',
    '审核状态':'Review Status',
    '审核失败原因':'Rejection Reason',
    '审核人':'Reviewed By',
    '审核时间':'Reviewed Time',
    '注销时间':'Deactivation Time',
    '保存':'Save',
    '修改':'Edit',
    '待审核':'Pending Review',
    '审核成功':'Approved',
    '审核失败':'Rejected',
  },

  '意见反馈': {
    '用户':'User',
    '处理状态':'Process Status',
    '备注':'Remark',
    '处理':'Process',
    '反馈图片':'Feedback Image',
    '联系方式':'Contact Information',
    '反馈类型':'Feedback Type',
    '反馈内容':'Feedback Content',
    '处理结果':'Process Result',
    '创建时间':'Create Time',
  },

  '物流公司信息': {
    '编号': 'Code',
    '公司名称': 'Company Name',
    '公司编码': 'Company Code',
    '公司类型': 'Company Type',
    '公司logo': 'Company Logo',
    '是否选用': 'Is Selected',
    '排序': 'Sort',
    '备注': 'Remark',
  },
  '报表': {
    '商品': {
      '订单开始时间': 'Order Start Time',
      '订单结束时间': 'Order End Time',
      '销售占比': 'Sales Ratio',
      '退款占比': 'Refund Ratio',
      '点击量': 'Clicks',
      '收藏量': 'Collections',
      '订单量': 'Order Quantity',
      '商品销量': 'Product Sales',
      '加购量': 'Cart Additions',
      '商品销售额': 'Product Sales Amount',
      '订单销售金额': 'Order Sales Amount',
      '销售金额': 'Sales Amount',
      '退款金额': 'Refund Amount',
      '退款单数': 'Refund Orders',
      '退款量': 'Refund Quantity',
    },
    '用户': {
      '注册开始时间': 'Registration Start Time',
      '注册结束时间': 'Registration End Time',
      '支付金额': 'Payment Amount',
      '最后下单时间': 'Last Order Time',
      '购买商品量': 'Products Purchased',
    },
  },

  '商品对账单': {
    '账单日期': 'Bill Date',
    '账单月份': 'Bill Month',
  },
  '交易单':{
    '交易单号':'Transaction Number',
    '订单编号':'Order Number',
    '订单类型':'Order Type',
    'ip':'IP',
    '支付方式':'Payment Method',
    '交易类型':'Transaction Type',
    '支付金额':'Payment Amount',
    '账期金额':'Billing Period Amount',
    '手续费':'Service Fee',
    '支付信息':'Payment Information',
    '三方订单号':'Third-party Order Number',
    '三方支付流水号':'Third-party Payment Number',
    '支付状态': 'Payment Status',
    '交易完成时间':'Transaction Completion Time',
    '创建时间':'Create Time',
    '过期时间':'Expiry Time',
    '备注':'Remark',
  },
  '常见问题':{
    '常见问题标题':'FAQ Title',
    '常见问题简述':'FAQ Description',
    '问题分类':'Question Category',
    '常见问题内容':'FAQ Content',
    '显示顺序':'Display Order',
    '状态':'Status',
    '备注':'Remark',
    '创建人':'Creator',
    '插入时间':'Insert Time',
    '修改人':'Modifier',
    '修改时间':'Modify Time',
    '版本号':'Version',
  },
  '常见问题分类':{
    '主图':'Main Image',
    '标题':'Title',
    '显示顺序':'Display Order',
    '备注':'Remark',
    '创建人':'Creator',
    '插入时间':'Insert Time',
    '修改人':'Modifier',
    '修改时间':'Modify Time',
    '版本号':'Version',
  },
  '店铺分类': {
    '店铺分类': 'Store Category',
    '分类名称': 'Category Name',
    '分类图片':'Category Image',
    '上级分类': 'Parent Category',
    '分类等级': 'Category Level',
    '是否显示': 'Visibility',
    '是否首页展示': 'Is Homepage Display',
    '是否参与筛选': 'Is Filterable',
    '创建时间': 'Create Time',
  },
  '入驻时长': {
    '入驻时长（年）': 'Settlement Duration (Years)',
    '分类名称': 'Category Name',
    '分类图片':'Category Image',
    '上级分类': 'Parent Category',
    '分类等级': 'Category Level',
    '是否显示': 'Visibility',
    '是否首页展示': 'Is Homepage Display',
    '是否参与筛选': 'Is Filterable',
    '创建时间': 'Create Time',
  },
  '主营行业': {
    '分类名称': 'Industry Name',
    '创建时间': 'Create Time',
  },
  '店铺': {
    '店铺名称': 'Store Name',
    '店铺logo': 'Logo',
    '店铺背景图':'Background Image',
    '客服电话': 'Customer Service Phone',
    '入驻时长': 'Settlement Duration (Years)',
    '入驻类型': 'Settlement Type',
    '店铺类型': 'Store Type',
    '是否推荐': 'Is Recommended',
    '推荐时间': 'Recommendation Time',
    '账户余额': 'Account Balance',
    '已结算金额': 'Settled Amount',
    '平台抽成比例': 'Platform Commission %',
    '营业执照号': 'Business License Number',
    '店铺状态': 'Store Status',
    '审核状态': 'Audit Status',
    '钱包开通状态': 'Wallet Status',
    '关键词': 'Keywords',
    '营业时间': 'Business Hours',
    '绑定时长': 'Binding Duration',
    '店铺分类': 'Store Category',
    '基础信息': 'Basic Information',
    '主营行业': 'Main Industry',
    '地址信息': 'Address Information',
    '店铺所在省份': 'Province',
    '店铺所在城市': 'City',
    '店铺所在县': 'County',
    '经度': 'Longitude',
    '纬度': 'Latitude',
    '详细地区': 'Detailed Address',
    '店铺简介': 'Store Introduction',
    '公司申请类型': 'Application Type',
    '店铺时间': 'Create Time',
    '入驻资料': 'Settlement Materials',
    '法人姓名': 'Legal Person Name',
    '法人手机号': 'Legal Person Phone',
    '法人邮箱': 'Legal Person Email',
    '法人身份证号': 'Legal Person ID',
    '身份证人像面': 'ID Front',
    '身份证国徽面': 'ID Back',
    '营业执照': 'Business License',
    '真实姓名': 'Real Name',
    '结算账户': 'Settlement Account',
    '银行预留手机号': 'Bank Reserved Phone',
    '结算银行开户名': 'Bank Account Name',
    '结算开户银行支行名称': 'Bank Branch Name',
    '开户行所在省份': 'Bank Province',
    '结算开户银行所在省': 'Settlement Bank Province',
    '开户行所在城市': 'Bank City',
    '自提时间': 'Self-pickup Time',
    '结算开户银行所在地': 'Settlement Bank Location',
    '审核信息': 'Audit Information',
    '保证金信息': 'Deposit Information',
    '保证金': 'Deposit',
    '打款备注': 'Payment Remark',
    '打款截图': 'Payment Screenshot',
    '店铺状态是否开启': 'Is Store Enabled',
  },
  '账户类型': {
    '账户类型名称': 'Account Type Name',
    '创建时间': 'Create Time',
  },
  '店铺标签': {
    '标签名称': 'Tag Name',
    '创建时间': 'Create Time',
  },
  '线下店铺套餐内容': {
    '备注': 'Package Title',
    '套餐标题': 'Package Title',
    '有效期': 'Validity Period Description',
    '使用时间': 'Usage Time Description',
    '使用规则': 'Usage Rules Description',
    '套餐logo': 'Content Image',
    '创建时间': 'Create Time',
    '是否需要预约': 'Need Appointment',
    '是否需要添加人员': 'Need Add Personnel',
  },
  '线下店铺套餐详情': {
    '商品套餐': 'Product Package',
    '套餐主标题': 'Package Main Title',
    '套餐副标题': 'Package Subtitle',
    '套餐详情价格': 'Package Price',
    '排序': 'Sort',
    '创建时间': 'Create Time',
    '套餐名称': 'Package Name',
    '手机号': 'Phone',
    '姓名': 'Name',
  },
  '线下报名':{
    '活动id':'Activity ID',
    '用户姓名':'User Name',
    '手机号':'Phone',
    '支付金额':'Payment Amount',
    '1微信支付 2支付宝':'1 WeChat Pay 2 Alipay',
    '0未支付，1支付成功，2支付失败':'0 Unpaid, 1 Payment Success, 2 Payment Failed',
    '插入时间':'Insert Time',
    '修改时间':'Modify Time',
    '创建人':'Creator',
    '活动名称':'Event Name',
    '修改人':'Modifier',
    '报名时间':'Registration Time',
  },
  '优惠券类型':{
    '店铺ID': 'Store ID',
    '发放店铺': 'Issuing Store',
    '优惠券名称': 'Coupon Name',
    '发放面额': 'Issued Amount',
    '发放数量': 'Issued Quantity',
    '每人最大领取个数 0无限制':'Max Per Person (0 Unlimited)',
    '满多少元使用':'Minimum Spend',
    '领取人会员等级':'Recipient Member Level',
    '使用范围':'Usage Range',
    '业务ID，与type合并使用，如type为1，全场可用，为2，分类id，以此类推':'Business ID (used with type)',
    '有效日期开始时间':'Valid Start Time',
    '有效日期结束时间':'Valid End Time',
    '优惠券状态':'Status',
    '是否允许首页显示0不显示1显示':'Homepage Display (0 No 1 Yes)',
    '优惠券详细信息':'Coupon Details',
    '是否新人优惠券':'Is New User Coupon',
    '创建时间':'Create Time',
    '修改时间':'Modify Time',
    '创建人':'Creator',
    '修改人':'Modifier',
    '逻辑删除标记 1:删除,0:未删除':'Delete Flag (1 Deleted, 0 Not)',
    '备注':'Remark',
    '店铺':'Store',
  },
  '秒杀时间轴':{
    '主键id':'ID',
    '秒杀开始时间':'Seckill Start Time',
    '秒杀结束时间':'Seckill End Time',
    '是否显示 0：否 1：是':'Visibility (0 No 1 Yes)',
    '活动名称':'Event Name',
    '创建时间':'Create Time',
    '修改时间':'Modify Time',
    '创建人':'Creator',
    '修改人':'Modifier',
    '逻辑删除标记 1:删除,0:未删除':'Delete Flag (1 Deleted, 0 Not)',
    '备注':'Remark',
  },
  '秒杀库存':{
    '主键id':'ID',
    '时间轴id':'Timeline',
    '商品id':'Product ID',
    '商品名称':'Product Name',
    '秒杀价格':'Seckill Price',
    '商品现价':'Current Price',
    '已经秒杀数量':'Seckilled Quantity',
    '商品图片':'Product Image',
    '秒杀商品库存':'Seckill Stock',
    '店铺id':'Store ID',
    '店铺名字':'Store Name',
    '状态':'Status',
    '秒杀是否完成0未完成 1已抢完':'Seckill Complete (0 No 1 Yes)',
    '拒绝原因':'Audit Opinion',
    '秒杀开始时间':'Seckill Start Time',
    '秒杀场次':'Seckill Session',
    '秒杀结束时间':'Seckill End Time',
    '最大购买数量':'Max Purchase Quantity',
    '创建时间':'Create Time',
    '修改时间':'Modify Time',
    '创建人':'Creator',
    '修改人':'Modifier',
    '逻辑删除标记 1:删除,0:未删除':'Delete Flag (1 Deleted, 0 Not)',
    '备注':'Remark',
  },
  '商家退货地址':{
    '商家退货地址id':'Return Address ID',
    '店铺id':'Store ID',
    '收货人名字':'Receiver Name',
    '收货人手机号码':'Receiver Phone',
    '收货人座机':'Receiver Landline',
    '邮政编码':'Postal Code',
    '省id':'Province ID',
    '省':'Province',
    '城市id':'City ID',
    '城市':'City',
    '区id':'District ID',
    '区':'District',
    '具体地址':'Detailed Address',
    '默认地址':'Is Default',
    '状态':'Is Available',
    '更新时间':'Update Time',
    '创建时间':'Create Time',
  },
  '用户标签':{
    '标签id':'Tag ID',
    '标签名称':'Tag Name',
    '创建时间':'Create Time',
    '修改时间':'Modify Time',
    '创建人':'Creator',
    '修改人':'Modifier',
    '备注':'Remark',
  },
  '系统日志':{
    '接口名称':'Interface Name',
    '操作人员':'Operator',
    '接口地址':'Interface Address',
    '请求入参':'Request Parameters',
    '接口出参':'Response Parameters'
  },
  '拼团活动商品':{
    '主键id':'ID',
    '店铺id':'Store ID',
    '商品id':'Product ID',
    '活动名称':'Event Name',
    '拼团有效期':'Group Validity',
    '发起拼团额外付的钱':'Extra Group Payment',
    '成团人数':'Group Members',
    '商品名称':'Product Name',
    '拼团价格':'Group Price',
    '原价':'Original Price',
    '商品图片':'Product Image',
    '状态': 'Status',
    '拒绝原因':'Rejection Reason',
    '拼团开始时间':'Group Start Time',
    '拼团结束时间':'Group End Time',
    '最大购买数量':'Max Purchase Quantity',
    '完成拼团数量':'Completed Groups',
    '总团数量':'Total Groups',
    '创建者':'Creator',
    '创建时间':'Create Time',
    '修改人':'Modifier',
    '更新时间':'Update Time',
    '逻辑删除标记':'Delete Flag',
    '租户ID':'Tenant ID',
    '备注':'Remark',
    '版本号':'Version',
  },
  '砍价活动配置':{
    'id':'ID',
    '店铺id':'Store ID',
    '活动名称':'Event Name',
    '活动开始时间':'Activity Start Time',
    '活动结束时间':'Activity End Time',
    '商品id':'Product ID',
    '商品图片':'Product Image',
    '商品名称':'Product Name',
    '商品原价':'Original Price',
    '审核状态':'Audit Status',
    '审核意见':'Audit Opinion',
    '多少人参与砍价即可成功':'Participants Required',
    '砍价活动价格':'Bargain Price',
    '该活动完成砍价数量':'Completed Bargains',
    '砍价有效期':'Bargain Validity',
    '创建者':'Creator',
    '创建时间':'Create Time',
    '修改人':'Modifier',
    '更新时间':'Update Time',
    '逻辑删除标记':'Delete Flag',
    '租户ID':'Tenant ID',
    '备注':'Remark',
    '版本号':'Version',
  },
  '用户提现':{
    '主键id':'ID',
    '未审核':'Unaudited',
    '审核未通过':'Audit Failed',
    '审核已通过':'Audit Passed',
    '支付宝':'Alipay',
    '微信':'WeChat',
    '银行卡':'Bank Card',
    '店铺ID':'Store ID',
    '店铺名称' :'Store Name',
    '提现金额':'Withdrawal Amount',
    '提现状态':'Withdrawal Status',
    '提现账号':'Withdrawal Account',
    '提现账号姓名':'Account Name',
    '提现手续费':'Withdrawal Fee',
    '提现方式':'Withdrawal Method',
    '1：普通用户提现 2：店铺提现4：直播提现5：承兑商提现':'Withdrawal Type',
    '第三方订单号(微信或支付的交易单号)':'Third-party Order Number',
    '失败原因':'Failure Reason',
    '审核意见':'Audit Opinion',
    '创建时间':'Create Time',
    '修改时间':'Modify Time',
    '创建人':'Creator',
    '修改人':'Modifier',
    '逻辑删除标记 1:删除,0:未删除':'Delete Flag (1 Deleted, 0 Not)',
    '备注':'Remark',
  },
  '预售活动商品配置':{
    'id':'ID',
    '店铺id':'Store ID',
    '活动名称':'Activity Name',
    '活动开始时间':'Activity Start Time',
    '活动结束时间':'Activity End Time',
    '商品id':'Product ID',
    '商品名称':'Product Name',
    '商品图片':'Product Image',
    '商品原价':'Original Price',
    '预售商品售卖价格':'Presale Price',
    '支付定金价格':'Deposit Price',
    '支付尾款价格(预售商品售卖价格-支付定金价格)':'Balance Price',
    '审核状态  1:待审核 2:审核未通过 3:审核通过 4:活动已结束（活动已结束后就不能再开始啦需要重新添加活动、商品下架后活动也会结束）':'Audit Status',
    '审核意见':'Audit Opinion',
    '总完成数量':'Total Completed',
    '尾款付款开始时间':'Balance Payment Start Time',
    '创建者':'Creator',
    '创建时间':'Create Time',
    '修改人':'Modifier',
    '更新时间':'Update Time',
    '逻辑删除标记':'Delete Flag',
    '租户ID，外键{tenant.id}':'Tenant ID',
    '备注':'Remark',
    '版本号':'Version',
    '流程说明':'Process Description',
  },
  '抽奖活动奖池配置':{
    'id':'ID',
    '名称':'Name',
    '图片':'Image',
    '奖励类型':'Reward Type',
    '奖励金额':'Reward Amount',
    '描述':'Description',
    '创建者':'Creator',
    '创建时间':'Create Time',
    '修改人':'Modifier',
    '更新时间':'Update Time',
    '逻辑删除标记':'Delete Flag',
    '租户ID，外键{tenant.id}':'Tenant ID',
    '备注':'Remark',
    '版本号':'Version',
    '排序':'Sort',
    '优惠券':'Coupon',
  },
  '抽奖活动中奖记录':{
    'id':'ID',
    '抽奖活动id':'Lottery Activity ID',
    '中奖信息文案':'Winning Message',
    '奖励类型':'Reward Type',
    '奖励金额':'Reward Amount',
    '商品id':'Product ID',
    '商品名称':'Product Name',
    '商品图片':'Product Image',
    '邮寄状态':'Shipping Status',
    '申请邮寄地址':'Apply Shipping Address',
    '姓名':'Name',
    '手机号':'Phone',
    '发货方式':'Shipping Method',
    '详细地址':'Detailed Address',
    '物流公司id':'Logistics Company ID',
    '物流公司名称':'Logistics Company Name',
    '寄件人手机号':'Sender Phone',
    '物流编号':'Tracking Number',
    '优惠券id':'Coupon ID',
    '优惠券名称':'Coupon Name',
    '创建者':'Creator',
    '创建时间':'Create Time',
    '修改人':'Modifier',
    '更新时间':'Update Time',
    '逻辑删除标记':'Delete Flag',
    '租户ID':'Tenant ID',
    '备注':'Remark',
    '版本号':'Version',
    '抽奖详情':'Lottery Details',
    '抽奖信息':'Lottery Information',
    '抽奖人昵称':'Participant Nickname',
    '抽奖人手机号':'Participant Phone',
    '抽奖人头像':'Participant Avatar',
  },
  '审核状态':{
    '待审核':'Pending Audit',
    '审核失败':'Audit Failed',
    '审核成功':'Audit Success',
    '过期未审核':'Expired Unaudited',
    '活动已结束':'Activity Ended',
  },
  '奖励类型':{
    '谢谢惠顾':'Thank You',
    '平台币':'Platform Coin',
    '商品':'Product',
    '优惠券':'Coupon',
  },
  '邮寄状态':{
    '待申请邮寄':'Pending Application',
    '待邮寄':'Pending Shipment',
    '已邮寄':'Shipped',
  },
  '用户角色类型':{
    '平台':'Platform',
    '商户':'Merchant',
    '店长':'Store Manager',
    '店员':'Store Staff',
    '用户':'User',
    '供应商':'Supplier',
  },
  '特价活动商品':{
    '主键id':'ID',
    '店铺id':'Store ID',
    '商品id':'Product ID',
    '活动名称':'Activity Name',
    '商品名称':'Product Name',
    '特价价格':'Special Price',
    '原价':'Original Price',
    '商品图片':'Product Image',
    '状态':'Status',
    '拒绝原因':'Rejection Reason',
    '创建者':'Creator',
    '创建时间':'Create Time',
    '修改人':'Modifier',
    '更新时间':'Update Time',
    '逻辑删除标记':'Delete Flag',
    '租户ID，外键{tenant.id}':'Tenant ID',
    '备注':'Remark',
    '版本号':'Version',
  },
  '参数设置':{
    '参数名称':'Parameter Name',
    '参数分组':'Parameter Group',
    '参数键名':'Parameter Key',
    '参数键值':'Parameter Value',
    '系统内置':'System Built-in',
    '创建时间':'Create Time',
    '备注':'Remark',
    '操作':'Operation',
  },
  '资讯管理':{
    '主键ID':'Primary Key ID',
    '标题':'Title',
    '发布人头像':'Publisher Avatar',
    '发布人':'Publisher',
    '观看量':'View Count',
    '内容详情富文本':'Rich Text Content',
    '排序':'Sort Order',
    '封面图':'Cover Image',
    '创建时间':'Create Time',
    '推荐尺寸':'Recommended Size',
  },
  '签到记录':{
    '用户昵称':'User Nickname',
    '是否签到':'Is Checked In',
    '签到时间':'Check-in Time',
    '连续签到天数':'Consecutive Days',
    '签到金币':'Check-in Reward (Coins)',
    '签到开始时间':'Check-in Start Date',
    '签到结束时间':'Check-in End Date',
  },
  '投票排行榜活动管理':{
    '新增活动':'Add Event',
    '新增商品':'Add Product',
    '主键ID':'Primary Key ID',
    '活动标题':'Event Title',
    '封面图':'Cover Image',
    '活动顶部图片':'Event Header Image',
    '简介':'Description',
    '类型（1,排行榜活动 2，投票活动）':'Type (1: Ranking Activity, 2: Voting Activity)',
    '活动规则':'Event Rules',
    '活动开始时间':'Event Start Time',
    '活动结束时间':'Event End Time',
    '排序':'Sort Order',
    '创建时间':'Create Time',
    '状态':'status',
    '活动奖励品':'Rewards',
    '投票商品':'Voting Products',
    '前几名商品中奖':'Top Winners(Produncts)',
  },
  '活动关联的商品':{
    '新增':'Add Product',
    '主键ID':'Primary Key ID',
    '活动id':'Activity ID',
    '活动名称':'Event Name',
    '商品名称':'Product Name',
    '活动商品图片':'Product Image',
    '阶梯积分':'Unlock Points',
    '投票数量':'Vote Count',
    '创建时间':'Create Time',
    '排序':'Sort Order',
  },
  '积分金币兑换记录':{
    '主键ID':'Primary Key ID',
    '用户昵称':'User Nickname',
    '用户手机号':'User Phone',
    '兑换码id':'Redemption Code ID',
    '兑换码':'Redemption Code',
    '兑换开始时间':'Redemption Start Time',
    '兑换结束时间':'Redemption End Time',
    '兑换数量':'Redemption Quantity',
    '兑换类型':'Redemption Type',
    '用户id':'User ID',
    '兑换时间':'Redemption Time',
  },
  '积分金币兑换码管理':{
    '主键ID':'Primary Key ID',
    '兑换码':'Redemption Code',
    '兑换数量':'Redemption Quantity',
    '兑换类型':'Redemption Type',
    '最多可兑换人数':'Max Redemption Users',
    '已兑换人数':'Redeemed Users',
    '创建时间':'Create Time',
  },
  '公告': {
    '正常': 'Normal',
    '关闭': 'Closed',
    '公告标题': 'Notice Title',
    '操作人员': 'Operator',
    '公告类型': 'Notice Type',
    '状态': 'Status',
    '创建时间': 'Create Time',
    '操作': 'Operation',
    '公告编号': 'Notice ID',
    '用户': 'User',
    '选择用户': 'Select Users',
    '标题': 'Title',
    '简介': 'Brief',
    '公告图片': 'Notice Image',
    '内容': 'Content',
    '发布': 'Publish',
    '取消': 'Cancel',
    '添加公告': 'Add Notice',
    '公告编辑': 'Edit Notice',
    '修改公告': 'Modify Notice',
    '确认删除所选中数据': 'Confirm to delete selected data?',
    '删除成功': 'Delete Success',
    '修改成功': 'Update Success',
    '新增成功': 'Add Success',
    '上传': 'Upload',
    '请输入标题': 'Please enter title',
    '请输入简介': 'Please enter brief',
    '请输入内容': 'Please enter content',
    '公告类型不能为空': 'Notice type cannot be empty',
    '公告标题不能为空': 'Notice title cannot be empty',
    '公告标题过长': 'Notice title is too long',
    '公告简介不能为空': 'Notice brief cannot be empty',
    '公告简介过长': 'Notice brief is too long',
    '上传图片大小不能超过 20MB!': 'Image size cannot exceed 20MB!',
    '共': 'Total',
    '条': 'records',
  }
}